module.exports = __webpack_public_path__ + "img/myposition_cb_파비오 칸나바로.41e2f83b.png";